


























import TableCell from '@/components/TableCell.vue'
import OrderRoutePickup from './order-common/OrderRoutePickup.vue'
import OrderRouteDropoff from './order-common/OrderRouteDropoff.vue'
import OrderDistance from '@/components/order-common/OrderDistance.vue'

export default {
  components: {
    TableCell,
    OrderRoutePickup,
    OrderRouteDropoff,
    OrderDistance
  },
  props: {
    multiStop: { type: Object, required: true },
    pickupStart: { type: String, default: '' },
    pickupEnd: { type: String, default: '' },
    deliveryStart: { type: String, default: '' },
    deliveryEnd: { type: String, default: '' },
    pickUphSpan: { type: Number, default: 0 },
    dropOffhSpan: { type: Number, default: 0 },
    hSpan: { type: Number, default: 8 }
  },
  computed: {
    addressWidth() {
      return this.hSpan / 2 - 1
    },
    multistopsNumber() {
      return this.multiStop.intermediateStops
    },
    multistops() {
      const { multistopsNumber } = this
      return `+ ${multistopsNumber} ${this.$tc(
        'marketPlace.order.multiStops',
        multistopsNumber
      )}`
    }
  }
}
